<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                     <h2 class="mb-4">
                        Job
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To understand that God is in control of every aspect of our lives.
                        </li>
                        <li>
                            To understand that we can trust God in his wisdom to care for us even in
                            difficult situations.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series focuses on Job and God rather than the ‘wisdom’ of Job's friends.
                        There are two distinct points of view:
                    </p>

                    <ul>
                        <li>
                            Earthly Viewpoint – From Job's perspective we see how painful life in a
                            broken world can be. The book of Job teaches that suffering is truly awful
                            and that Satan still has power on earth even now (week 1).
                        </li>
                        <li>
                            Heavenly Viewpoint – Behind the scenes, however, it is clear that this is
                            not the whole story. Satan's power is limited, but God's is not (week 1).
                            God is in control of all things, he has a wise plan for our lives and
                            he cares for us (week 2).
                        </li>
                    </ul>

                    <p>
                        The book of Job teaches us the importance of keeping both points of
                        view in mind when we ourselves or people we know are struggling.
                        Job did not blindly praise God for the pain he experiences –
                        he mourned and wept over what he had lost, but he also trusted
                        that God would act in accordance with his good nature.
                        We cannot understand from our earthly perspective everything
                        that God is doing when we suffer, but we can be certain that our
                        circumstances are never beyond his control or outside of his plan
                        and that his love for us will never change.
                    </p>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - Big Problems! (Job 1:1-2:10)
                    </p>
                    <p>
                        Lesson 2 - Bigger God! (Job 38:1-11, 39-41; 41:1-11; 42:1-6, 10-17)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Job",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Job`,
            meta: [
                {
                    name: 'description',
                    content: "To understand that we can trust God in his wisdom to care for us even in difficult situations.",
                },
            ],
        };
    },
};
</script>
